export function uniqueId() {
  return new Date().getTime().toString(36) + new Date().getUTCMilliseconds();
}
